module.exports = __webpack_public_path__ + "static/media/view assigned grade coordinator.064d235f.svg";